// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fade-in-out {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

h3 {
    color: #4ECDC4; /* Change to your desired color */
}


.circle-green {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: green;
  animation: fade-in-out 3s ease infinite; /* Updated animation properties */
}

.circle-red {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: red;
  animation: fade-in-out 1s ease infinite; /* Updated animation properties */
}

.circle-yellow {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: yellow;
  animation: fade-in-out 1.7s ease infinite; /* Updated animation properties */
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.dialog-box {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-align: center;
  max-width: 400px;
  color: #000; /* Set the text color to black */
}

.dialog-box p {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  word-wrap: break-word;
}

.dialog-box button {
  margin: 5px;
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
}

.dialog-box button:first-child {
  background-color: #008000;
  color: #fff;
}

.dialog-box button:last-child {
  background-color: #ff0000;
  color: #fff;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/CircleSensorApp.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;IACI,cAAc,EAAE,iCAAiC;AACrD;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,uCAAuC,EAAE,iCAAiC;AAC5E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,uCAAuC,EAAE,iCAAiC;AAC5E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,yCAAyC,EAAE,iCAAiC;AAC9E;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW,EAAE,gCAAgC;AAC/C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["@keyframes fade-in-out {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\nh3 {\n    color: #4ECDC4; /* Change to your desired color */\n}\n\n\n.circle-green {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: green;\n  animation: fade-in-out 3s ease infinite; /* Updated animation properties */\n}\n\n.circle-red {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: red;\n  animation: fade-in-out 1s ease infinite; /* Updated animation properties */\n}\n\n.circle-yellow {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: yellow;\n  animation: fade-in-out 1.7s ease infinite; /* Updated animation properties */\n}\n\n.dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.dialog-box {\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  text-align: center;\n  max-width: 400px;\n  color: #000; /* Set the text color to black */\n}\n\n.dialog-box p {\n  margin: 0;\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  word-wrap: break-word;\n}\n\n.dialog-box button {\n  margin: 5px;\n  padding: 8px 16px;\n  font-size: 14px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.dialog-box button:first-child {\n  background-color: #008000;\n  color: #fff;\n}\n\n.dialog-box button:last-child {\n  background-color: #ff0000;\n  color: #fff;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
